import { ApiResponse } from '../api'
import { axios } from '@src/lib/axios'

export interface PagePermissionsDto {
  [moduleName: string]: boolean | { [subModule: string]: boolean }
}

export type GetPagePermissionsRespDto = PagePermissionsDto

/** 取得頁面權限 */
export async function getPagePermissions(): Promise<GetPagePermissionsRespDto> {
  const response = await axios.get<ApiResponse<GetPagePermissionsRespDto>>('/api/web/user/page-permissions')

  return response.data
}

export interface PermissionDto {
  uuid: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  fnCode: string;
  description: string;
}

export type GetPermissionsRespDto = PermissionDto[]

/** 取得權限清單 */
export async function getPermissions(): Promise<GetPermissionsRespDto> {
  const response = await axios.get<ApiResponse<GetPermissionsRespDto>>('/api/web/user/permissions')

  return response.data
}

export interface RoleDto {
  uuid: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  fnCode: string;
  description: string;
}

export type GetRolesRespDto = RoleDto[]

/** 取得角色清單 */
export async function getRoles(): Promise<GetRolesRespDto> {
  const response = await axios.get<ApiResponse<GetRolesRespDto>>('/api/web/user/roles')

  return response.data
}

export interface FactoryDto {
  uuid: string;
  code: string;
  description: string;
  stations: {uuid: string; code: string; description: string}[]
}

export type FactoriesRespDto = FactoryDto[]

/** 取得廠區清單 */
export async function getFactories(): Promise<FactoriesRespDto> {
  const response = await axios.get<ApiResponse<FactoriesRespDto>>(`/api/web/factories`)

  return response.data
}
